"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _notification = require("./notification.style");
var _Icon = _interopRequireDefault(require("../Icon"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Notification(_a) {
  var {
      className = 'notification',
      variant = 'info',
      fit = 'medium',
      icon,
      heading,
      body,
      actions,
      showClose = false,
      onClose
    } = _a,
    rest = __rest(_a, ["className", "variant", "fit", "icon", "heading", "body", "actions", "showClose", "onClose"]);
  return (0, _jsxRuntime.jsxs)(_notification.Components.Wrapper, (0, _extends2["default"])({
    className: className,
    fit: fit,
    variant: variant,
    icon: icon
  }, rest, {
    children: [icon && (0, _jsxRuntime.jsx)(_Icon["default"], {
      name: icon,
      size: fit === 'large' ? '24' : '20'
    }), (0, _jsxRuntime.jsxs)(_notification.Components.Content, {
      children: [heading && (0, _jsxRuntime.jsx)(_notification.Components.Heading, (0, _extends2["default"])({
        fit: fit
      }, {
        children: heading
      })), (0, _jsxRuntime.jsx)(_notification.Components.Body, (0, _extends2["default"])({
        fit: fit
      }, {
        children: body
      })), (0, _jsxRuntime.jsx)(_notification.Components.Actions, (0, _extends2["default"])({
        fit: fit
      }, {
        children: Array.isArray(actions) && actions.length > 0 ? actions.map((action, index) => (0, _jsxRuntime.jsx)(_notification.Components.LinkWrapper, {
          children: (0, _jsxRuntime.jsx)(_notification.Components.Link, (0, _extends2["default"])({
            href: action.url
          }, {
            children: action.label
          }))
        }, index)) : actions
      }))]
    }), showClose && (0, _jsxRuntime.jsx)(_notification.Components.CloseButton, (0, _extends2["default"])({
      "aria-label": "notification close",
      onClick: () => {
        if (onClose) {
          onClose();
        }
      }
    }, {
      children: (0, _jsxRuntime.jsx)(_Icon["default"], {
        name: "times",
        size: fit === 'large' ? '24' : '20'
      })
    }))]
  }));
}
var _default = exports["default"] = Notification;